import React from 'react';
import { FiFileText, FiFilm, FiImage, FiMusic, FiVideo } from 'react-icons/fi';
import { MdFolder } from 'react-icons/md';
import { colorTagHex } from './itemMetaDisplay';

/** Matches backend DEFAULT_LIBRARY folder names (case-insensitive). */
const PREDEFINED_FOLDER_ICONS = {
  documents: { Icon: FiFileText, modifierClass: 'sb-drive-icon--folder-documents' },
  media: { Icon: FiFilm, modifierClass: 'sb-drive-icon--folder-media' },
  pictures: { Icon: FiImage, modifierClass: 'sb-drive-icon--folder-pictures' },
  music: { Icon: FiMusic, modifierClass: 'sb-drive-icon--folder-music' },
  videos: { Icon: FiVideo, modifierClass: 'sb-drive-icon--folder-videos' },
  video: { Icon: FiVideo, modifierClass: 'sb-drive-icon--folder-videos' },
};

const DEFAULT_FOLDER = { Icon: MdFolder, modifierClass: 'sb-drive-icon--folder' };

export function hasPredefinedStorageBoxFolderIcon(folderName) {
  const key = String(folderName || '').trim().toLowerCase();
  return Boolean(PREDEFINED_FOLDER_ICONS[key]);
}

export function resolveStorageBoxFolderIcon(folderName) {
  const key = String(folderName || '').trim().toLowerCase();
  return PREDEFINED_FOLDER_ICONS[key] || DEFAULT_FOLDER;
}

export function StorageBoxFolderIcon({ name, folderColor = '', className = '' }) {
  const { Icon, modifierClass } = resolveStorageBoxFolderIcon(name);
  const classes = ['sb-drive-icon', modifierClass, className].filter(Boolean).join(' ');
  const customHex =
    !hasPredefinedStorageBoxFolderIcon(name) && folderColor ? colorTagHex(folderColor) : null;
  return <Icon className={classes} style={customHex ? { color: customHex } : undefined} aria-hidden />;
}
